import React from 'react';
import { PrimaryButton, TextField, Selection, DetailsList, CheckboxVisibility } from 'office-ui-fabric-react';
import axios from 'axios';
import config from '../config';
import moment from 'moment';

export default class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            isUploading: false,
        }
    }

    componentDidMount() {
        axios.get(config.apiUrl + '/files')
        .then(data => this.setState({
            files: data.data
        }))
    }

    upload() {
        if (this.state.isUploading) return;
        if (!this.refs.tag.value || !this.refs.tag.value.trim()) {
            alert('Enter your tab name, please');
            return;
        }
        var files = this.refs.file.files;
        if (files.length == 0) return;
        var formData = new FormData();
        formData.append("image", files[0]);
        formData.append("tag", this.refs.tag.value);
        this.setState({
            isUploading: true
        })
        axios.post(config.apiUrl + '/files/upload', formData, {
            headers: {
            'Content-Type': 'multipart/form-data'
            }
        })
        .then(() => {
            this.setState({
                isUploading: false
            });
            this.refs.file.value = "";
            this.refs.tag.value = "";
            axios.get(config.apiUrl + '/files')
                .then(data => this.setState({
                    files: data.data
                }))
        })
        .catch(() => {
            this.setState({
                isUploading: false
            })
            alert('Cannot upload file');
        })
    }

    showDelete(e) {
        if (confirm('Do you want delete ' + e.name + "?")) {
            axios.post(config.apiUrl + '/files/delete/' + e._id)
                .then(() => {
                    axios.get(config.apiUrl + '/files')
                    .then(data => this.setState({
                        files: data.data
                    }))
                })
        }
    }

    render() {
        var processCollum = columns.find(e => e.key == 'delete');
        processCollum.onRender = (e) => {
            return <div>
                <button className="tbl-btn" onClick={() => this.showDelete(e)}>
                    <i className="ms-Icon ms-Icon--Delete" aria-hidden="true"></i>
                </button>
            </div>;
        }
        return (
            <div style={{padding: 15}}>
                <div>
                    <h2>Upload new data</h2>
                    <div style={{marginBottom: 5}}>
                        <input ref="tag" type="text" placeholder="tab name"></input>
                        <input ref="file" type="file" accept=".csv" />
                    </div>
                    <PrimaryButton text={this.state.isUploading ? 'Uploading' : 'Upload'} onClick={() => this.upload()} />
                </div>
                <div style={{marginTop: 20}}>
                    <DetailsList
                        items={this.state.files}
                        columns={columns}
                        checkboxVisibility={CheckboxVisibility.hidden}
                        style={{ fontSize: 20 }}
                    />
                </div>
            </div>
        );
    }
}

const columns = [{
    key: 'name',
    name: 'File Name',
    fieldName: 'name',
    minWidth: 300,
    maxWidth: 300,
    onRender(e) {
        return <a href={`/upload-files/${e.name}`} target="_blank">{e.name}</a>
    }
}, {
    key: 'tag',
    name: 'Tab Name',
    fieldName: 'tag',
    minWidth: 200,
    maxWidth: 200,
}, {
    key: 'createdAt',
    fieldName: 'createdAt',
    name: 'Uploaded At',
    minWidth: 150,
    maxWidth: 150,
    onRender(e) {
        return moment(e.createdAt).format('hh:mm MMM DD YYYY');
    }
}, {
    key: 'process',
    name: 'Process',
    fieldName: 'process',
    minWidth: 300,
    maxWidth: 300
}, {
    key: 'status',
    name: 'Status',
    fieldName: 'status',
    minWidth: 100,
    maxWidth: 100
}, {
    key: 'delete',
    name: '',
    minWidth: 100,
    maxWidth: 100
}]


// WEBPACK FOOTER //
// ./client/components/ImportData.js